import { useMutation } from '@apollo/client'
import {
  RemoveTagFromCandidateDocument,
  RemoveTagFromCandidateMutationVariables,
} from 'generated/resources/graphql'

export const useRemoveTagFromCandidate = () => {
  const [removeCandidateTag, { loading }] = useMutation(RemoveTagFromCandidateDocument)

  return {
    loading,
    removeTag(variables: RemoveTagFromCandidateMutationVariables) {
      return removeCandidateTag({
        variables,
      })
    },
  }
}
